import { render, staticRenderFns } from "./_base-newnav.vue?vue&type=template&id=1f1fc04a&scoped=true&"
import script from "./_base-newnav.vue?vue&type=script&lang=js&"
export * from "./_base-newnav.vue?vue&type=script&lang=js&"
import style0 from "./_base-newnav.vue?vue&type=style&index=0&id=1f1fc04a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1fc04a",
  null
  
)

export default component.exports